/**
 * Brass Discipline: tighter groups, all the time.
 *
 * The flat one in the column. Every tree needs a node that is worth taking without a plan, or the
 * first two levels are spent reading rather than playing.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const BRASS_DISCIPLINE = {
  id: 'brassDiscipline',
  branch: 'gunplay',
  tier: 1,
  title: 'Brass Discipline',
  blurb: 'Count your rounds. Account for your rounds. Rounds are Halcyon property.',
  maxRanks: 3,
  minLevel: 3,
  requires: [],
  statGrants: {},
  effects: [{ field: 'weaponSpread', perRank: -0.06, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
